import { render, staticRenderFns } from "./BrandEdit.vue?vue&type=template&id=d2a728bc&scoped=true"
import script from "./BrandEdit.vue?vue&type=script&lang=js"
export * from "./BrandEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a728bc",
  null
  
)

export default component.exports